<mat-progress-bar
  mode="indeterminate"
  color="warn"
  [style.display]="loading ? 'block' : 'none'"
/>

<h2 class="m-4 nowrap">
  <span class="titulo">
    <span class="cursor-pointer" (click)="volver()">Clientes</span>
    >
    {{ titulo }}
  </span>
</h2>

@if (formulario) {
  <form
    id="form"
    [formGroup]="formulario"
    (ngSubmit)="enviar()"
    autocomplete="off"
  >
    <div class="m-2">
      <mat-tab-group class="tabs-form" [(selectedIndex)]="tabSeleccionada">
        <!-- ============================ GENERAL ============================ -->
        <mat-tab>
          <ng-template mat-tab-label>
            General
            @if (tabInvalida(controlesTabs.general)) {
              <mat-icon color="warn" class="ic-error">error_outline</mat-icon>
            }
          </ng-template>
          <div class="contenido-tab">
            <div class="subgrupo">
              <h2>Datos básicos</h2>

              <mat-form-field
                matTooltip="Define la carpeta donde se suben las imágenes del cliente: ponelo antes de cargar archivos"
              >
                <mat-label>Nombre</mat-label>
                <input
                  matInput
                  placeholder="Nombre del cliente"
                  formControlName="nombre"
                  required
                />
                <mat-hint>Definilo antes de subir imágenes.</mat-hint>
              </mat-form-field>

              <app-autocomplete-direccion
                [direccion]="data?.configuracion?.direccion || ''"
                (direccionChange)="selectDireccion($event)"
                style="width: 100%"
              />

              <mat-form-field>
                <mat-label>Tipo</mat-label>
                <mat-select formControlName="tipo" required>
                  @for (dato of tiposCliente; track dato) {
                    <mat-option [value]="dato">{{ dato }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field>
                <mat-label>País</mat-label>
                <mat-select formControlName="pais" required>
                  @for (pais of paisesDisponibles; track pais) {
                    <mat-option [value]="pais.codigo">
                      {{ pais.codigoPais }} - {{ pais.codigo }}
                    </mat-option>
                  }
                </mat-select>
                <mat-hint>Configuración regional del cliente</mat-hint>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Edad Mínima</mat-label>
                <input
                  type="number"
                  matInput
                  placeholder="Edad mínima para registro de vecinos"
                  formControlName="edadMinima"
                />
                @if (formulario.controls["edadMinima"].hasError("required")) {
                  <mat-error>Este campo es obligatorio.</mat-error>
                }
                @if (formulario.controls["edadMinima"].hasError("min")) {
                  <mat-error>El valor debe ser mayor a 1.</mat-error>
                }
                @if (formulario.controls["edadMinima"].hasError("max")) {
                  <mat-error>El valor debe ser menor a 21.</mat-error>
                }
              </mat-form-field>

              <mat-form-field>
                <mat-label>Twitter</mat-label>
                <input
                  matInput
                  placeholder="@municipio"
                  formControlName="twitter"
                />
              </mat-form-field>

              <mat-form-field>
                <mat-label>Email</mat-label>
                <input
                  matInput
                  placeholder="ejemplo@dominio.com"
                  formControlName="email"
                />
              </mat-form-field>

              <mat-form-field [formGroup]="configuracion">
                <mat-label>Host Smart City</mat-label>
                <input
                  matInput
                  placeholder="Host Smart City"
                  formControlName="hostSmartCity"
                />
              </mat-form-field>

              <div class="row-wrap gap-15px">
                <mat-checkbox formControlName="sirenas">
                  Usa sirenas
                </mat-checkbox>
                <mat-checkbox formControlName="porticos">
                  Usa pórticos
                </mat-checkbox>
              </div>
            </div>

            <div class="subgrupo">
              <h2>Territorio</h2>
              <div class="mt-2 mb-2">
                <app-polygon-draw
                  [coordenadas]="data?.coordenadas || []"
                  [otrosPoligonos]="otrosClientes"
                  [buscadorOsm]="true"
                  [height]="'60vh'"
                  [zoom]="9"
                />
              </div>
            </div>

            <!-- Atajos para no cargar 20 imágenes a mano en un cliente nuevo. -->
            <div class="subgrupo">
              <h2>Atajos de imágenes</h2>
              <p class="nota">
                Cargan las imágenes base del cliente. Se ven y se editan una por
                una en la pestaña <strong>App Nativa</strong>.
              </p>
              <div class="row-wrap align-center gap-15px">
                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  [disabled]="!nombre || loading"
                  (click)="aplicarSetGenerico()"
                >
                  <mat-icon>auto_fix_high</mat-icon>
                  Aplicar set genérico GPE
                </button>

                <mat-form-field style="min-width: 240px">
                  <mat-label>Copiar imágenes de...</mat-label>
                  <mat-select [(value)]="idClienteACopiar">
                    @for (c of clientes; track c._id) {
                      <mat-option [value]="c._id">{{ c.nombre }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <button
                  mat-stroked-button
                  type="button"
                  [disabled]="!idClienteACopiar"
                  (click)="copiarImagenesDe()"
                >
                  Copiar
                </button>

                <button
                  mat-stroked-button
                  color="warn"
                  type="button"
                  [disabled]="!cantidadImagenesCargadas"
                  (click)="vaciarImagenes()"
                >
                  <mat-icon>delete_sweep</mat-icon>
                  Vaciar imágenes
                </button>
              </div>
            </div>
          </div>
        </mat-tab>

        <!-- ========================== CATEGORÍAS ========================== -->
        <mat-tab>
          <ng-template mat-tab-label>
            Categorías
            @if (categoriasInvalidas) {
              <mat-icon color="warn" class="ic-error">error_outline</mat-icon>
            }
          </ng-template>
          <div class="contenido-tab">
            <app-categorias-seccion
              [formulario]="formulario"
              [categorias]="categorias"
              [categoriasCatalogo]="categoriasCatalogo"
              [botonesCatalogo]="botonesCatalogo"
              [usoPorCategoria]="usoPorCategoria"
              [usoVecinos]="usoVecinos"
              [reemplazosCategorias]="reemplazosCategorias"
            />
          </div>
        </mat-tab>

        <!-- ========================== APP NATIVA ========================== -->
        <mat-tab>
          <ng-template mat-tab-label>
            App Nativa
            @if (tabInvalida(controlesTabs.appNativa)) {
              <mat-icon color="warn" class="ic-error">error_outline</mat-icon>
            }
          </ng-template>
          <div class="contenido-tab">
            <!-- categoriasEditables vacío: las categorías viven en su propia pestaña. -->
            <app-tab-app-nativa
              [formulario]="formulario"
              [esEdicion]="esEdicion"
              [botones]="botonesCatalogo"
              [categoriasEditables]="[]"
              [idsBtnsServiciosTramites]="idsBtnsServiciosTramites"
              (subirFuente)="setFuente($event)"
            />
          </div>
        </mat-tab>

        <!-- =========================== SIRENAS ============================ -->
        <mat-tab>
          <ng-template mat-tab-label>
            Sirenas
            @if (tabInvalida(controlesTabs.sirenas)) {
              <mat-icon color="warn" class="ic-error">error_outline</mat-icon>
            }
          </ng-template>
          <div class="contenido-tab">
            <app-tab-sirenas
              [formulario]="formulario"
              [clientes]="clientes"
              [botones]="botonesCatalogo"
            />
          </div>
        </mat-tab>

        <!-- ==================== MONITOREO / INTEGRACIONES ================== -->
        <mat-tab>
          <ng-template mat-tab-label>
            Monitoreo / Integraciones
            @if (tabInvalida(controlesTabs.monitoreo)) {
              <mat-icon color="warn" class="ic-error">error_outline</mat-icon>
            }
          </ng-template>
          <div class="contenido-tab">
            <app-tab-monitoreo-integraciones
              [formulario]="formulario"
              [botones]="botonesCatalogo"
            />
          </div>
        </mat-tab>

        <!-- ========================== WEB LEGACY =========================== -->
        <mat-tab label="Web Legacy">
          <div class="contenido-tab">
            <app-tab-web-legacy [formulario]="formulario" />
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </form>
}

<div class="barra-acciones mat-elevation-z8">
  <!-- Por qué el Guardar está deshabilitado. Clickeando cada ítem se va a su pestaña. -->
  @if (faltantes.length) {
    <div class="faltantes">
      <mat-icon>error_outline</mat-icon>
      <span class="faltantes-lbl">Falta para poder guardar:</span>
      @for (f of faltantes; track f.texto) {
        <button
          type="button"
          class="chip-falta"
          matTooltip="Ir a la pestaña donde se completa"
          (click)="irATab(f.tab)"
        >
          {{ f.texto }}
        </button>
      }
    </div>
  }

  <button
    class="botonSpinner"
    mat-raised-button
    color="primary"
    type="submit"
    [disabled]="loading || !puedeGuardar"
    form="form"
  >
    <div class="loadSpinnerButton" [style.display]="loading ? 'flex' : 'none'">
      <mat-spinner
        class="mx-2"
        [diameter]="25"
        mode="indeterminate"
        color="warn"
      />
    </div>
    <span [style.display]="loading ? 'none' : 'block'">Guardar</span>
  </button>

  <button mat-raised-button type="button" (click)="volver()">Volver</button>
</div>
